import { useQuery } from '@tanstack/react-query';

import { catalogQueries } from '@/lib/queries/catalog';

/**
 * Admin-managed horizontal navigation under the top bar, with the §3 silver
 * rule below it. Reuses the Increment 1 catalog menu stub. The bar (and its
 * silver rule) survives even when there are no items — against stubs it's empty
 * but the rule still anchors the layout.
 */
export function MenuBar() {
  const { data: items = [] } = useQuery(catalogQueries.menuItems());
  const visible = items.filter((i) => i.is_visible);

  return (
    <nav className="border-b border-silver/40">
      <div className="flex min-h-[2.5rem] items-center gap-6 overflow-x-auto px-6">
        {visible.map((item) => (
          <a
            key={item.id}
            href={item.href}
            className="whitespace-nowrap font-sans text-sm text-video-text-muted transition hover:text-video-text"
          >
            {item.label}
          </a>
        ))}
      </div>
    </nav>
  );
}
